import React from 'react'

function About() {
  return (
    <div style={styles.pageContainer}>
      <h1 style={styles.heading}>About Us</h1>
      <p style={styles.paragraph}>
        Our passion for travel and exploration drives us to curate 
        unforgettable adventures around the globe. With years of experience 
        in the travel industry, our team ensures you get the best itineraries, 
        comfortable accommodations, and unparalleled customer service.
      </p>
      <p style={styles.paragraph}>
        Whether you're looking for a solo trip, a romantic getaway, or a fun 
        family vacation, we're here to help you create memories that last a lifetime.
      </p>
    </div>
  )
}

const styles = {
  pageContainer: {
    backgroundColor: '#F4F9F9',
    padding: '2rem',
    minHeight: '70vh',
  },
  heading: {
    fontFamily: 'Georgia, serif',
    color: '#34495E',
    marginBottom: '1rem',
  },
  paragraph: {
    fontSize: '1.1rem',
    lineHeight: '1.6',
    color: '#2C3E50',
    marginBottom: '1.5rem',
  },
}

export default About
